import {
  FormControlLabel,
  Radio,
  Grid,
  FormControl,
  Typography,
  OutlinedInput,
  RadioGroup,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import BasicInput from "../../../component/input/basic-input/BasicInput";
import { Member } from "../../../models/data/members/Member";
import MemberSectionType from "../../../models/types/memberSectionTypes/memberSectionType";
import { useEducationSectionStyles } from "./educationSectionStyles";

interface Props {
  member: Member;
  onChange: any;
}

export const MemberEducationData = ({ member, onChange }: Props) => {
  const { t } = useTranslation();
  const { classes } = useEducationSectionStyles();

  const handleOnKeyPressed = (
    event: React.KeyboardEvent<HTMLInputElement>,
    id: string
  ) => {
    if (event.key === "Enter") {
      console.log("Enter key pressed");
      switch (id) {
        case "memberEducationData_input-elementarySchool":
          var elementarySchool = document.getElementById(
            "memberEducationData_input-elementarySchool"
          );
          elementarySchool?.focus();
          break;
        case "memberEducationData_input-highSchool":
          var highSchool = document.getElementById(
            "memberEducationData_input-highSchool"
          );
          highSchool?.focus();
          break;
        case "memberEducationData_input-basicVocationalSchool":
          var basicVocationalSchool = document.getElementById(
            "memberEducationData_input-basicVocationalSchool"
          );
          basicVocationalSchool?.focus();
          break;
        case "memberEducationData_input-specialistVocationalSchool":
          var specialistVocationalSchool = document.getElementById(
            "memberEducationData_input-specialistVocationalSchool"
          );
          specialistVocationalSchool?.focus();
          break;
        case "memberEducationData_input-academicStudies":
          var academicStudies = document.getElementById(
            "memberEducationData_input-academicStudies"
          );
          academicStudies?.focus();
          break;
        case "memberEducationData_input-academicStudies":
          var academicStudies = document.getElementById(
            "memberEducationData_input-academicStudies"
          );
          academicStudies?.focus();
          break;
        case "memberEducationData_input-masterAcademicStudies":
          var masterAcademicStudies = document.getElementById(
            "memberEducationData_input-masterAcademicStudies"
          );
          masterAcademicStudies?.focus();
          break;
        case "memberEducationData_input-specialistAcademicStudies":
          var specialistAcademicStudies = document.getElementById(
            "memberEducationData_input-specialistAcademicStudies"
          );
          specialistAcademicStudies?.focus();
          break;
        case "memberEducationData_input-doctoralAcademicStudies":
          var doctoralAcademicStudies = document.getElementById(
            "memberEducationData_input-doctoralAcademicStudies"
          );
          doctoralAcademicStudies?.focus();
          break;
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <BasicInput
          id="memberEducationData_input-elementarySchool"
          label={t("memberManagementPage.educationElementarySchool")}
          value={member?.education?.elementarySchool}
          onChange={(e) =>
            onChange(
              e.target.value,
              "elementarySchool",
              MemberSectionType.memberEducation
            )
          }
          onKeyDown={(e: any) =>
            handleOnKeyPressed(e, "memberEducationData_input-highSchool")
          }
        />
      </Grid>

      {/*HIGH SCHOOL */}
      <Grid item lg={12} md={12} sm={12}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Typography variant="body1" className={classes.inputTitle}>
            {t("memberManagementPage.educationHighSchool")}:
          </Typography>
        </Grid>
        <Grid container>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              fullWidth
            >
              <OutlinedInput
                id="memberEducationData_input-highSchool"
                fullWidth
                value={member?.education?.highSchool}
                onChange={(e) =>
                  onChange(
                    e.target.value,
                    "highSchool",
                    MemberSectionType.memberEducation
                  )
                }
                className={classes.input}
                onKeyDown={(e: any) =>
                  handleOnKeyPressed(
                    e,
                    "memberEducationData_input-basicVocationalSchool"
                  )
                }
              />
            </FormControl>
          </Grid>
          <Grid item lg={4}>
            <FormControl>
              <RadioGroup name="highSchoolYear">
                <Grid container>
                  <Grid item className={classes.radioButton}>
                    <FormControlLabel
                      value={
                        member?.education?.highSchoolYear !== null &&
                        member?.education?.highSchoolYear === 3
                          ? true
                          : false
                      }
                      checked={
                        member?.education?.highSchoolYear !== null &&
                        member?.education?.highSchoolYear === 3
                          ? true
                          : false
                      }
                      control={
                        <Radio
                          id="memberEducationData_radioButton-highSchoolYearThree"
                          className={classes.radioButton}
                          onClick={(e) =>
                            onChange(
                              3,
                              "highSchoolYear",
                              MemberSectionType.memberEducation
                            )
                          }
                        />
                      }
                      label={
                        <Typography variant="body1" color="textSecondary">
                          {t("memberManagementPage.educationLevelThird")}
                        </Typography>
                      }
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 14,
                        },
                      }}
                    />
                    <FormControlLabel
                      value={
                        member?.education?.highSchoolYear !== null &&
                        member?.education?.highSchoolYear === 4
                          ? true
                          : false
                      }
                      checked={
                        member?.education?.highSchoolYear !== null &&
                        member?.education?.highSchoolYear === 4
                          ? true
                          : false
                      }
                      control={
                        <Radio
                          id="memberEducationData_radioButton-highSchoolYearFour"
                          className={classes.radioButton}
                          onClick={(e) =>
                            onChange(
                              4,
                              "highSchoolYear",
                              MemberSectionType.memberEducation
                            )
                          }
                        />
                      }
                      label={
                        <Typography variant="body1" color="textSecondary">
                          {t("memberManagementPage.educationLevelFourth")}
                        </Typography>
                      }
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 14,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>

      {/*BASIC VOCATINAL SCHOOL*/}
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <BasicInput
          id="memberEducationData_input-basicVocationalSchool"
          label={t("memberManagementPage.educationBasicVocationalSchool")}
          value={member?.education?.basicVocationalStudies}
          onChange={(e) =>
            onChange(
              e.target.value,
              "basicVocationalStudies",
              MemberSectionType.memberEducation
            )
          }
          onKeyDown={(e: any) =>
            handleOnKeyPressed(
              e,
              "memberEducationData_input-specialistVocationalSchool"
            )
          }
        />
      </Grid>

      {/*SPECIALIST VOCATINAL SCHOOL */}
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <BasicInput
          id="memberEducationData_input-specialistVocationalSchool"
          label={t("memberManagementPage.educationSpecialistVocationalSchool")}
          value={member?.education?.specialVocationalStudies}
          onChange={(e) =>
            onChange(
              e.target.value,
              "specialVocationalStudies",
              MemberSectionType.memberEducation
            )
          }
          onKeyDown={(e: any) =>
            handleOnKeyPressed(e, "memberEducationData_input-academicStudies")
          }
        />
      </Grid>

      {/*ACADEMIC STUDIES */}
      <Grid item lg={12} md={12} sm={12}>
        <Grid item lg={8} md={8} sm={12} xs={12}>
          <Typography variant="body1" className={classes.inputTitle}>
            {t("memberManagementPage.educationAcademicStudies")}:
          </Typography>
        </Grid>
        <Grid container>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              fullWidth
            >
              <OutlinedInput
                id="memberEducationData_input-academicStudies"
                fullWidth
                value={member?.education?.academicStudies}
                onChange={(e) =>
                  onChange(
                    e.target.value,
                    "academicStudies",
                    MemberSectionType.memberEducation
                  )
                }
                onKeyDown={(e: any) =>
                  handleOnKeyPressed(
                    e,
                    "memberEducationData_input-masterAcademicStudies"
                  )
                }
                className={classes.input}
              />
            </FormControl>
          </Grid>
          <Grid item lg={4} md={4} sm={12}>
            <FormControl>
              <Grid container>
                <Grid item className={classes.radioButton}>
                  <FormControlLabel
                    value={
                      member?.education?.academicStudiesYear !== null &&
                      member?.education?.academicStudiesYear === 3
                        ? true
                        : false
                    }
                    checked={
                      member?.education?.academicStudiesYear !== null &&
                      member?.education?.academicStudiesYear === 3
                        ? true
                        : false
                    }
                    control={
                      <Radio
                        id="memberEducationData_radioButton-academicStudiesYearThree"
                        className={classes.radioButton}
                        onClick={(e) =>
                          onChange(
                            3,
                            "academicStudiesYear",
                            MemberSectionType.memberEducation
                          )
                        }
                      />
                    }
                    label={
                      <Typography variant="body1" color="textSecondary">
                        {t("memberManagementPage.educationLevelThird")}
                      </Typography>
                    }
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 14,
                      },
                    }}
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    value={
                      member?.education?.academicStudiesYear !== null &&
                      member?.education?.academicStudiesYear === 4
                        ? true
                        : false
                    }
                    checked={
                      member?.education?.academicStudiesYear !== null &&
                      member?.education?.academicStudiesYear === 4
                        ? true
                        : false
                    }
                    control={
                      <Radio
                        id="memberEducationData_radioButton-academicStudiesYearFour"
                        className={classes.radioButton}
                        onClick={(e) =>
                          onChange(
                            4,
                            "academicStudiesYear",
                            MemberSectionType.memberEducation
                          )
                        }
                      />
                    }
                    label={
                      <Typography variant="body1" color="textSecondary">
                        {t("memberManagementPage.educationLevelFourth")}
                      </Typography>
                    }
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 14,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item lg={12} md={12} sm={12}>
        <Grid item lg={8} md={8} sm={12} xs={12}>
          <Typography variant="body1" className={classes.inputTitle}>
            {t("memberManagementPage.educationMasterAcademicStudies")}:
          </Typography>
        </Grid>
        <Grid container>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              fullWidth
            >
              <OutlinedInput
                id="memberEducationData_input-masterAcademicStudies"
                fullWidth
                value={member?.education?.masterAcademicStudies}
                onChange={(e) =>
                  onChange(
                    e.target.value,
                    "masterAcademicStudies",
                    MemberSectionType.memberEducation
                  )
                }
                className={classes.input}
                onKeyDown={(e: any) =>
                  handleOnKeyPressed(
                    e,
                    "memberEducationData_input-specialistAcademicStudies"
                  )
                }
              />
            </FormControl>
          </Grid>
          <Grid item lg={4} md={4} sm={12}>
            <FormControl>
              <Grid container>
                <Grid item className={classes.radioButton}>
                  <FormControlLabel
                    value={
                      member?.education?.masterAcademicStudiesYear !== null &&
                      member?.education?.masterAcademicStudiesYear === 3
                        ? true
                        : false
                    }
                    checked={
                      member?.education?.masterAcademicStudiesYear !== null &&
                      member?.education?.masterAcademicStudiesYear === 3
                        ? true
                        : false
                    }
                    control={
                      <Radio
                        id="memberEducationData_radioButton-masterAcademicStudiesYearThree"
                        className={classes.radioButton}
                        onClick={(e) =>
                          onChange(
                            3,
                            "masterAcademicStudiesYear",
                            MemberSectionType.memberEducation
                          )
                        }
                      />
                    }
                    label={
                      <Typography variant="body1" color="textSecondary">
                        {t("memberManagementPage.educationLevelThird")}
                      </Typography>
                    }
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 14,
                      },
                    }}
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    value={
                      member?.education?.masterAcademicStudiesYear !== null &&
                      member?.education?.masterAcademicStudiesYear === 4
                        ? true
                        : false
                    }
                    checked={
                      member?.education?.masterAcademicStudiesYear !== null &&
                      member?.education?.masterAcademicStudiesYear === 4
                        ? true
                        : false
                    }
                    control={
                      <Radio
                        id="memberEducationData_radioButton-masterAcademicStudiesYearThreeFour"
                        className={classes.radioButton}
                        onClick={(e) =>
                          onChange(
                            4,
                            "masterAcademicStudiesYear",
                            MemberSectionType.memberEducation
                          )
                        }
                      />
                    }
                    label={
                      <Typography variant="body1" color="textSecondary">
                        {t("memberManagementPage.educationLevelFourth")}
                      </Typography>
                    }
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 14,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <BasicInput
          id="memberEducationData_input-specialistAcademicStudies"
          label={t("memberManagementPage.educationSpecialistAcademicStudies")}
          value={member?.education?.specialAcademicStudies}
          onChange={(e) =>
            onChange(
              e.target.value,
              "specialAcademicStudies",
              MemberSectionType.memberEducation
            )
          }
          onKeyDown={(e: any) =>
            handleOnKeyPressed(
              e,
              "memberEducationData_input-doctoralAcademicStudies"
            )
          }
        />
      </Grid>
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <BasicInput
          id="memberEducationData_input-doctoralAcademicStudies"
          label={t("memberManagementPage.educationDoctoralAcademicStudies")}
          value={member?.education?.doctoralAcademicStudies}
          onChange={(e) =>
            onChange(
              e.target.value,
              "doctoralAcademicStudies",
              MemberSectionType.memberEducation
            )
          }
          onKeyDown={(e: any) =>
            handleOnKeyPressed(
              e,
              "memberEducationData_input-doctoralAcademicStudies"
            )
          }
        />
      </Grid>
      <Grid item lg={12} sm={8}>
        <Grid item lg={8} sm={12} xs={12}>
          <Typography variant="h6" className={classes.inputTitle}>
            {t("memberManagementPage.educationComputerSkills")}:
          </Typography>
        </Grid>
        <Grid item lg={4}>
          <FormControl>
            <Grid container>
              <Grid item>
                <FormControlLabel
                  style={{ alignContent: "center" }}
                  value={
                    member?.education?.workOnComputer !== null &&
                    member?.education?.workOnComputer === true
                      ? true
                      : false
                  }
                  checked={
                    member?.education?.workOnComputer !== null &&
                    member?.education?.workOnComputer === true
                      ? true
                      : false
                  }
                  control={
                    <Radio
                      id="memberEducationData_radioButton-workOnComputerYes"
                      className={classes.radioButton}
                      onClick={(e) =>
                        onChange(
                          true,
                          "workOnComputer",
                          MemberSectionType.memberEducation
                        )
                      }
                    />
                  }
                  label={
                    <Typography variant="body1" color="textSecondary">
                      {t("memberManagementPage.educationYes")}
                    </Typography>
                  }
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 14,
                    },
                  }}
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  value={
                    member?.education?.workOnComputer !== null &&
                    member?.education?.workOnComputer === false
                      ? true
                      : false
                  }
                  checked={
                    member?.education?.workOnComputer !== null &&
                    member?.education?.workOnComputer === false
                      ? true
                      : false
                  }
                  control={
                    <Radio
                      id="memberEducationData_radioButton-workOnComputerNo"
                      className={classes.radioButton}
                      onClick={(e) =>
                        onChange(
                          false,
                          "workOnComputer",
                          MemberSectionType.memberEducation
                        )
                      }
                    />
                  }
                  label={
                    <Typography variant="body1" color="textSecondary">
                      {t("memberManagementPage.educationNo")}
                    </Typography>
                  }
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 14,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};
